import { useEffect } from "react";
import { useGetEntitiesQuery } from "store/apis/group";
import { useAppSelector } from "./useAppSelector";
import { useRoleBasedView } from "./useRoleBasedView";
import { useAppDispatch } from "./useAppDispatch";
import { setIsSnackbar } from "store/slices/dashboard";

export const useDashboardBanner = () => {
  const dispatch = useAppDispatch();
  const { subscriptionsInactive } = useAppSelector(
    (state) => state.subscriptionModal
  );
  const { isCustomer } = useRoleBasedView();
  const { data: { groups: [group] = [null] } = {} } = useGetEntitiesQuery();

  useEffect(() => {
    dispatch(
      setIsSnackbar(
        Boolean(group?.due_amount) || subscriptionsInactive.length > 0
      )
    );
  }, [dispatch, group?.due_amount, subscriptionsInactive.length]);

  const showReviveSubscription = isCustomer && subscriptionsInactive.length > 0;
  const showUnpaidDues =
    isCustomer && !showReviveSubscription && group && group.due_amount > 0;

  const shouldRenderBanner = showReviveSubscription || showUnpaidDues;

  return {
    shouldRenderBanner,
    showReviveSubscription,
    showUnpaidDues,
    dueAmount: group?.due_amount,
  };
};
